export enum AttachmentsListFilterTypes {
  Show_All = 'Show All',
  Media = 'Media',
  Files = 'Files',
}
